module.exports = __webpack_public_path__ + "static/media/CURSOR.08f1608e.png";